import React from 'react';

function Addunitebutton({handeladdunite}) {

  return (
    <div className='addunitebutton'
      onClick={handeladdunite}
    >
        + 
    </div>
  );
}

export default Addunitebutton;